import { createAction, props } from '@ngrx/store';
import { IAddBankRequest, IAddBankResponse, ISaveBankFormRequest } from '../models/employee-bank-detail.model';

export const addBank = createAction(
  '[Bank] Add Bank',
  props<{ request: { customerId: string, body: ISaveBankFormRequest } }>()
);

export const addBankSuccess = createAction(
  '[Bank] Add Bank Success',
  props<{ response: IAddBankResponse }>()
);

export const addBankFailure = createAction(
  '[Bank] Add Bank Failure',
  props<{ error: any }>()
);